module.exports = __webpack_public_path__ + "media/images/maps/pins/digi_pin_large (copy)-fd838607bb92bd42134c86eb6aa14d21.png";